import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ForwardOnHoverModule } from "../forward-on-hover/forward-on-hover.module";
import { ActionsComponent } from "./actions.component";

@NgModule({
  declarations: [ActionsComponent],
  imports: [CommonModule, ForwardOnHoverModule],
  exports: [ActionsComponent],
})
export class BkUiActionsModule { }
